import React, { useState } from 'react';
import UserServices from '../../../services/UserServices';
import PlanServices from '../../../services/PlanServices';
import CommanServices from '../../../services/ComanServices';
const UserStatus = ({ user,page ,onSuccess}) => {
  // Initialize the state based on the user's status
  const [isChecked, setIsChecked] = useState(user?.status === 'active');

  // Handle checkbox toggle
  const handleToggle = async () => {
    const newStatus = !isChecked ? 'active' : 'inactive';
    setIsChecked(!isChecked);
    if(page === 'user'){
     try {
      const res = await UserServices.updateUser(user._id, {
        status: newStatus
      });

      onSuccess();
     } catch (error) {
      alert('There is an error while updating the status');
     }
    }else if(page === 'plan'){
      try {
        const res = await PlanServices.updatePlan(user._id, {
          status: newStatus
        });
  
        onSuccess();
       } catch (error) {
        alert('There is an error while updating the status');
       }
    }else if(page === 'blog'){
      try {
        const res = await CommanServices.updateBlog(user._id, {
          status: newStatus
        });
  
       } catch (error) {
        alert('There is an error while updating the status');
       }
    }else if(page === 'stock'){
      try {
        const res = await CommanServices.updateStock(user._id, {
          status: newStatus
        });
  
       } catch (error) {
        alert('There is an error while updating the status');
       }
    }
  };

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default UserStatus;
